$('.js-footer-dropdown').on('click', function() {
    $(this).toggleClass('_active');
});

App.document.ready(() => {
    if (App.W.width() < 768) {
        setHeightFooterDropdowns();
    }

    App.W.on('resize', () => {
        setHeightFooterDropdowns();
    });
});

function setHeightFooterDropdowns() {
    $('.js-footer-dropdown-content').each((ind, item) => {
        let height = 40;
        $(item).find('.footer-nav__item').each((ind, line) => {
            height += $(line).innerHeight();
        });
        $(item).css('max-height', height);
    });
}

$('.js-phone-select').on('change', (e) => {
    const currentPhoneTitle = $(e.target).find('option:selected').data('phone-title');
    const currentPhoneCall = $(e.target).find('option:selected').data('phone-call');

    $('.js-phone-title').text(currentPhoneTitle);
    $('.js-phone-call').attr('href', `tel: ${currentPhoneCall}`);
});